import { apiClient } from './client';
import { reportSchema } from './schemas';
import type { Report } from './types';

export const reportsApi = {
  async get(from: string, to: string): Promise<Report> {
    return apiClient.get<Report>(`/reports?from=${from}&to=${to}`, reportSchema);
  },
};
